import gql from 'graphql-tag'

export default gql`
    query downloadAbacus(
        $shopId: [ID]!
        $datePeriod: FullDateTimeIntervalInput!
        $detailedExport: Boolean
    ) {
        cashAssist {
            downloadAbacus(shopId: $shopId, datePeriod: $datePeriod, detailedExport: $detailedExport) {
                success
				messages
                link
                linkCreditor
            }
        }
    }
`
